var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image',{attrs:{"width":_vm.width,"height":_vm.height,"xlink:href":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }